import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const ConfirmDeleteDialog = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          backgroundColor: '#ffffff', 
          borderRadius: '8px', 
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' 
        }
      }}
    >
      <DialogTitle
        style={{
          fontSize: '1.25rem', 
          fontWeight: '500', 
          color: '#333' 
        }}
      >
        {t('dialog.confirmDeleteTitle')}
      </DialogTitle>
      <DialogContent
        style={{
          marginBottom: '16px' 
        }}
      >
        <Typography
          style={{
            fontSize: '1rem', 
            color: '#666' 
          }}
        >
          {t('dialog.confirmDeleteMessage')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          style={{
            color: '#666',
            fontWeight: '500', 
            textTransform: 'none', 
            fontSize: '1rem' 
          }}
        >
          {t('dialog.cancelButton')}
        </Button>
        <Button
          onClick={handleConfirm}
          style={{
            backgroundColor: '#2979ff', 
            color: '#ffffff', 
            fontWeight: '500', 
            textTransform: 'none', 
            boxShadow: 'none', 
            borderRadius: '4px', 
            fontSize: '1rem' 
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = '#1565c0')}
          onMouseOut={(e) => (e.target.style.backgroundColor = '#2979ff')}
          autoFocus
        >
          {t('dialog.confirmButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
